import script from "./FeedbackReaction.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackReaction.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackReaction.vue?vue&type=style&index=0&id=7370fd48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7370fd48"]])

export default __exports__